var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReactjs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_601_6847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 19.4716C17.5758 19.4716 18.8528 18.2157 18.8528 16.6666C18.8528 15.1174 17.5758 13.8616 16.0006 13.8616C14.4254 13.8616 13.1484 15.1174 13.1484 16.6666C13.1484 18.2157 14.4254 19.4716 16.0006 19.4716Z",
    fill: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 22.4136C24.452 22.4136 31.304 19.8406 31.304 16.6667C31.304 13.4929 24.452 10.9199 15.9997 10.9199C7.5473 10.9199 0.695312 13.4929 0.695312 16.6667C0.695312 19.8406 7.5473 22.4136 15.9997 22.4136Z",
    stroke: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9392 19.5401C15.1654 26.739 20.8571 31.2883 23.652 29.7014C26.4468 28.1145 25.2866 20.9921 21.0604 13.7933C16.8342 6.59439 11.1425 2.04501 8.3476 3.63196C5.55271 5.2189 6.713 12.3412 10.9392 19.5401Z",
    stroke: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9395 13.7933C6.71334 20.9922 5.55305 28.1145 8.34794 29.7014C11.1428 31.2884 16.8345 26.739 21.0607 19.5401C25.2869 12.3412 26.4472 5.2189 23.6523 3.63196C20.8574 2.04502 15.1657 6.59439 10.9395 13.7933Z",
    stroke: "#61DAFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_601_6847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactjs);
export default __webpack_public_path__ + "static/media/reactjs.db0cbd7f324a048f8a33a6bf52904341.svg";
export { ForwardRef as ReactComponent };